export const ptLang = {
  languageKey: 'pt',
  translates: {
    IDENTITY_DOCUMENT_TYPE: 'Tipo de Documento',
    IDENTITY_DOCUMENT_DNI: 'DNI',
    IDENTITY_DOCUMENT_NIE: 'NIE',
    IDENTITY_DOCUMENT_CIF: 'CIF',
    IDENTITY_DOCUMENT_SPANISH_PASSPORT: 'Passaporte Espanhol',
    IDENTITY_DOCUMENT_FOREIGN_PASSPORT: 'Passaporte Estrangeiro',
    IDENTITY_DOCUMENT_OTHER: 'Outros',
    IDENTITY_DOCUMENT_NOT_AVAILABLE: 'Não consta',
    IDENTITY_DOCUMENT_NUMBER: 'Número de identidade',
    nif: 'NIF/NIE/Passaporte/CIF',
  },
};
